
export function replyToPublicCommentAction() {
  return {
    restrict: 'E',
    template: require('./reply-to-public-comment-action.directive.html'),
    scope: {
      action: '=',
      readonly: '<',
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {

  $scope.addMessage = addMessage;
  $scope.removeMessage = removeMessage;
  init();


  function addMessage() {
    $scope.action.parameters.messages.push(null);
  }

  function removeMessage(index) {
    $scope.action.parameters.messages.splice(index, 1);
  }


  function init() {
  }
}




